export enum Subscriptions {
  free = 'Free',
  basic = 'Basic',
  pro = 'Pro',
  enterprise = 'Enterprise'
}

export interface DataAccessPolicy {
  maxVisibleSessions: number; // Max sessions user can see (based on plan)
  maxAccessibleCVs: number; // Max CVs user can access (based on plan)
  archivedSessionCount: number; // Count of archived sessions
  archivedCVCount: number; // Count of archived CVs
  lastPolicyUpdate: Date; // When policy was last updated
  gracePeriodEnd?: Date; // End of grace period for data access
  downgradedFrom?: string; // Previous plan name if downgraded
}

export interface Subscription {
  name: string;
  description?: string;
  // Interview Features
  sessions: number;
  frequency: number;
  emailReminder: boolean;
  fileUpload: boolean;
  interviewLengths: string[];
  recordingLength: number;

  // NEW: Job Analysis & CV Features
  jobAnalysisSessions: number;
  cvGenerations: number;
  cvStorageLimit: number;
  companyResearch: boolean;
  skillsGapAnalysis: 'none' | 'basic' | 'advanced';
  atsOptimization: boolean;
  exportFormats: string[];

  // Data access policy
  dataAccessPolicy?: DataAccessPolicy;

  // Payment
  priceId: string;
  amount: number;
  price: string; // Display-friendly price string

  // UI properties for compatibility
  recommended?: boolean;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
  buttonText?: string;
  buttonLink?: string;
  features?: string[];
}

import { environmentPricingService } from '../../services/environment-pricing.service';

// Use environment-aware plans
export const enhancedPlans: Subscription[] = environmentPricingService.getPlansForCurrentEnvironment();

// Usage tracking interfaces
export interface JobAnalysisUsage {
  userId: string;
  month: string; // YYYY-MM format
  sessionsUsed: number;
  limit: number;
  lastReset: Date;
}

export interface CVGenerationUsage {
  userId: string;
  month: string; // YYYY-MM format
  generationsUsed: number;
  limit: number;
  lastReset: Date;
}

export interface CVStorageUsage {
  userId: string;
  cvsStored: number;
  limit: number;
}

export interface InterviewSessionUsage {
  userId: string;
  month: string; // YYYY-MM format
  sessionsUsed: number;
  limit: number;
  lastReset: Date;
}

export interface PracticeAttemptUsage {
  userId: string;
  month: string; // YYYY-MM format
  attemptsUsed: number;
  limit: number;
  lastReset: Date;
}
